var ForgotPasswordDialogView = require('forgotpassworddialogview');
var Formatter = require('formatter');
var util = require('../lib/util.es6');


var LandingView = Backbone.View.extend({
    el: 'body',
    initialize: function (options) {
        this.formatter = new Formatter();
        if (!this.model.ent()) {
            this.model.getPlans();
        }
        this.setupAnimations();

        this.model.bind('hashDialogHide', this.model.back, this.model);
        this.model.bind('navigate', this.navigate, this);
        this.model.bind('plansChange', this.renderPlans, this);
        
        this.startPath = window.location.pathname;
        this.router = new Backbone.Router();
        this.router.route('*catchAll', 'catchAllRoute', _.bind(this.catchAllRoute, this));
        this.router.route('!/*networkString', 'promptNetwork', _.bind(this.promptNetwork, this));
        this.router.route('irc/*networkString', 'promptNetwork', _.bind(this.promptNetwork, this));
        this.router.route('?/irc_url=*ircUrl', 'ircUrl', _.bind(this.ircUrl, this));
        this.router.route('?/error=:error', 'showError', _.bind(this.showError, this));
        this.router.route('?/team-error=:error', 'showError', _.bind(this.showError, this));
        this.router.route('?/account-deleted', 'showAccountDeleted', _.bind(this.showAccountDeleted, this));
        this.router.route('?/invite=:invite&email=:email', 'fillSignup', _.bind(this.fillSignup, this));
        this.router.route('?/invite=:invite&email=:email&url=*url', 'fillSignup', _.bind(this.fillSignup, this));
        this.router.route('?/team-invite=:key&email=:email&team=:name', 'fillOrgSignup', _.bind(this.fillOrgSignup, this));
        this.router.bind('route', this.model.onRoute, this.model);
        this.router.bind('route', this.onRoute, this);
        
        options.router = this.router;
        this.forgotPassword = new ForgotPasswordDialogView(options);
        
        Backbone.history.start({pushState: true});

        this.formsDisabled = true;
        this.enableForms();

        $('#enterpriseLandingContainer').fadeIn('fast');
    },
    events: {
        'submit form.signin': 'signIn',
        'submit form.signupForm': 'signUp',
        'buttonClick .samlLogin': 'samlLogin'
    },
    samlLogin: function () {
        window.location = "/saml/auth";
    },
    areFormsDisabled: function () {
        return this.formsDisabled;
    },
    disableForms: function () {
        if (!this.areFormsDisabled()) {
            this.formsDisabled = true;
            this.$('form, form input, form button[type=submit], form textarea').blur().prop('disabled', true);
        }
    },
    enableForms: function () {
        if (this.areFormsDisabled()) {
            this.formsDisabled = false;
            this.$('form, form input, form button[type=submit], form textarea').prop('disabled', false);
        }
    },
    renderPlans: function () {
        var soloAmount = this.model.plans.solo.amount;
        var solo = this.formatter.amount(
            this.model.plans.currency,
            soloAmount,
            1,
            soloAmount % 100 ? 2: 0
        );
        var soloAnnualPlan = this.model.plans.solo_yearly[this.model.plans.currency];
        var soloAnnual;
        if (soloAnnualPlan) {
            var soloAnnualAmount = this.model.plans.solo_yearly[this.model.plans.currency].amount;
            soloAnnual = this.formatter.amount(
                this.model.plans.currency,
                soloAnnualAmount,
                1,
                soloAnnualAmount % 100 ? 2: 0
            );
        }
        var teamAmount = this.model.plans.org.per_seat;
        var team = this.formatter.amount(
            this.model.plans.currency,
            teamAmount,
            1,
            teamAmount % 100 ? 2: 0
        );

        var soloVat = '';
        var teamVat = '';

        if (this.model.plans.eu_vat.applicable) {
            soloVat = 'Includes VAT';
            var vatCountry = _.find(this.model.plans.eu_vat.countries, function (c) {
                return c.code === this.model.plans.vat_country;
            }, this);
            var vatRate = '';
            var vatCountryCode = '';
            if (vatCountry) {
                vatRate = vatCountry.rate + '%';
                vatCountryCode = ' (' + vatCountry.name + ')';
            }
            teamVat = '+' + vatRate + ' VAT' + vatCountryCode; 
        }

        $('table.pricing td.free p.price').text(this.formatter.getCurrencySymbol(this.model.plans.currency) + 0);
        $('table.pricing td.solo p.price').text(solo);
        $('table.pricing td.solo span.annual_price').text(soloAnnual);
        $('table.pricing td.solo p.vat').text(soloVat);
        $('table.pricing td.team p.price').text(team);
        $('table.pricing td.team p.vat').text(teamVat);
    },
    isHome: function () {
        return this.startPath === '/';
    },
    catchAllRoute: function (route, args) {
        if (!this.isHome() && !route && !args) {
            window.location = "/";
        }
    },
    onRoute: function (route, args) {
        if (!_.include(['fillOrgSignup', 'fillSignup', 'promptNetwork', 'ircUrl'], route)) {
            $('.signupNetworkInfo').hide();
        }
    },
    ircUrl: function (ircUrl) {
        var parts = util.ircUrlParts(decodeURIComponent(ircUrl));
        this.navigate('irc/' + parts.url, {replace: true, trigger: true});
    },
    promptNetwork: function (networkId) {
        var bufferParts = util.getBufferParts(networkId);
        var legacyBufferParts = util.getBufferPartsLegacy(
            networkId, Backbone.history.getHash()
        );
        if (legacyBufferParts) {
            if (
                !bufferParts ||
                !bufferParts.hostname ||
                (!bufferParts.buffer && legacyBufferParts.buffer)
            ) {
                bufferParts = legacyBufferParts;
            }
        }
        $('.signupNetworkInfo').hide();
        if (bufferParts && bufferParts.buffer) {
            $('.signupNetworkInfo .channel').text(bufferParts.buffer);
            $('.signupNetworkInfo .network').text(bufferParts.hostname);
            $('.signupNetworkInfo.channel').show();
        } else if (bufferParts && bufferParts.hostname) {
            $('.signupNetworkInfo .network').text(bufferParts.hostname);
            $('.signupNetworkInfo.network').show();
        }
    },
    showError: function (error) {
        var msg;
        switch (error) {
        case 'invalid_invite':
            msg = 'Invalid invite key';
            break;
        case "redeemed_elsewhere":
            msg = "This invite has already been used";
            break;
        case "org_deleted":
            msg = "This team has been deleted";
            break;
        case "invite_revoked":
            msg = "This invite has been revoked";
            break;
        default:
            msg = 'An error occurred';
            break;
        }
        $('#landingSignup').find('.userError').text(msg).fadeIn('fast');
    },
    showAccountDeleted: function () {
        $('#accountDeleted').fadeIn('fast');
    },
    navigate: function (url, options) {
        this.router.navigate(url, options);
    },
    signIn: function (e) {
        e.preventDefault();
        var form = $(e.target);
        form.addSpin();
        form.find('.userError').hide();
        this.model.signin({
            email: form.find('[name=email]').val(),
            password: form.find('[name=password]').val(),
            org_invite: form.find('[name=org_invite]').val(),
            invite_url: form.find('[name=invite_url]').val()
        }, _.bind(function (response) {
            if (response.success) {
                this.model.startRefresh(response.session, response.url);
            } else {
                form.removeSpin();
                var msg;
                switch (response.message) {
                case "auth":
                    msg = 'Incorrect email or password';
                    break;
                case "email":
                    msg = 'Email left blank';
                    break;
                case "password":
                    msg = 'Password left blank';
                    break;
                case "rate_limited":
                    msg = 'Rate limited, try again in a few mins';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                case "email_exists":
                    msg = 'An account with this email already exists';
                    break;
                case "password_too_long":
                    msg = 'Maximum password length: ' + window.IRCConfig.max_password_length;
                    break;
                case "password_error":
                    msg = 'Invalid password, try again';
                    break;
                case "external_failed":
                    msg = 'Authentication server error';
                    break;
                default:
                    msg = 'Error signing in';
                    break;
                }
                form.find('.userError').text(msg).fadeIn('fast');
            }
        }, this));
    },
    fillOrgSignup: function (key, email, orgName) {
        return this.fillSignup(key, email, undefined, orgName);
    },
    fillSignup: function (key, email, url, orgName) {
        if (orgName) {
            this.$('[name=invite]').val('');
            this.$('[name=org_invite]').val(key);
            $('#signupOrgName').text(decodeURIComponent(orgName));
            $('#signupOrgInfo').show();
        } else {
            this.$('[name=invite]').val(key);
            this.$('[name=org_invite]').val('');
        }
        this.$('[name=signup_email]').val(decodeURIComponent(email));
        if (url) {
            this.$('[name=invite_url]').val(url);
            this.navigate('irc/' + url, {replace: true, trigger: true});
        }
    },
    signUp: function (e) {
        e.preventDefault();
        var form = $(e.target);
        form.addSpin();
        form.find('.userError').hide();
        this.model.signup({
            email: form.find('.input[name=signup_email]').val(),
            password: form.find('.input[name=signup_password]').val(),
            realname: form.find('.input[name=signup_realname]').val(),
            invite: form.find('[name=invite]').val(),
            org_invite: form.find('[name=org_invite]').val(),
            invite_url: form.find('[name=invite_url]').val()
        }, _.bind(function (response) {
            if (response.success) {
                // Start session
                this.model.startRefresh(response.session, response.url);
            } else {
                form.removeSpin();
                var msg;
                switch (response.message) {
                case 'email':
                    msg = 'Invalid email address';
                    break;
                case 'email_exists':
                    msg = 'This email address is already in use, please sign in or try another';
                    break;
                case 'invalid_invite':
                    msg = 'Invalid invite key';
                    break;
                case 'password':
                    msg = 'Invalid password';
                    break;
                case "password_too_long":
                    msg = 'Maximum password length: ' + window.IRCConfig.max_password_length;
                    break;
                case "password_error":
                    msg = 'Invalid password, try again';
                    break;
                case 'realname':
                    msg = 'Invalid real name';
                    break;
                case 'banned':
                    msg = 'Signup server unavailable, please try again later';
                    break;
                case 'bad_email':
                    msg = 'No signups allowed from that domain';
                    break;
                case "invalid_form_token":
                    msg = 'Invalid form token';
                    break;
                case 'rate_limited':
                    msg = 'Too many signups from your IP. Try again later.';
                    break;
                case 'ip_banned':
                    msg = 'Signup server unavailable, please try again later';
                    break;
                case 'tor_blocked':
                    msg = 'No signups allowed from TOR exit nodes';
                    break;
                case 'signup_ip_blocked':
                    msg = 'Your IP address has been blacklisted';
                    break;
                default:
                    msg = 'Error signing up your account: ' + response.message;
                    break;
                }
                form.find('.userError').text(msg).fadeIn('fast');
            }
        }, this));
    },

    IPHONE_LEFT: 485,
    ANDROID_RIGHT: 220,
    ORG_POS: 240,
    animate: function () {
        var scrollTop = $(window).scrollTop();
        var viewport = $(window).height();
        var scrollBottom = scrollTop + viewport;

        // Organise
        if ($('#landingOrganise').length) {
            var orgTop = $('#landingOrganise').offset().top;
            var orgBottom = orgTop + $('#landingOrganise').outerHeight(true);
            var orgDiffBottom = orgBottom - scrollBottom;
            var orgTopThresh = 0;
            if (orgDiffBottom > -orgTopThresh) {
                $('#landingOrganiseContainer').css('background-position', -this.ORG_POS + 'px 0');
            } else if (orgDiffBottom + orgTopThresh < -this.ORG_POS) {
                $('#landingOrganiseContainer').css('background-position', '0 0');
            } else {
                $('#landingOrganiseContainer').css('background-position', (-orgDiffBottom - orgTopThresh - this.ORG_POS) + 'px 0');
            }
        }

        // Phones
        if ($('#landingMobileDevices').length) {
            var mobTop = $('#landingMobileDevices').offset().top;
            var mobBottom = mobTop + $('#landingMobileDevices').outerHeight(true);
            var distanceToStart = scrollBottom - mobTop;
            var diffBottom = mobBottom - scrollBottom;
            var topThresh = 100;
            if (distanceToStart < 0 || 
                diffBottom < -topThresh) {
                $('#landingMobileIphone').css('margin-left', -this.IPHONE_LEFT);
                $('#landingMobileAndroid').css('margin-left', this.ANDROID_RIGHT);
            } else {
                $('#landingMobileIphone').css('margin-left', -(diffBottom+topThresh) - this.IPHONE_LEFT);
                $('#landingMobileAndroid').css('margin-left', (diffBottom+topThresh) + this.ANDROID_RIGHT);
            }
        }
    },
    setupAnimations: function () {
        this.animate();
        $(window).scroll(_.bind(this.animate, this));
    }
});


module.exports = LandingView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/landingview.js
// module id = X5r2
// module chunks = 3